import Auth from '../../Helpers/auth';
const API_URL = process.env.REACT_APP_BACKEND_URL;
// GET: Fetches a company - protected route
async function httpGetCompany(id) {
  const token = Auth.getToken();
  try {
    let company = await fetch(`${API_URL}/companies/actions/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await company.json();
  } catch (err) {
    return err;
  }
}
// GET: Fetches the companys managers
async function httpGetCompanyManagers(id) {
  const token = Auth.getToken();
  try {
    let managers = await fetch(
      `${API_URL}/companies/employees/managers/${id}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await managers.json();
  } catch (err) {
    return err;
  }
}

// GET: Fetches the company's employees
async function httpGetCompanyEmployees(id) {
  const token = Auth.getToken();

  try {
    let employees = await fetch(`${API_URL}/companies/employees/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await employees.json();
  } catch (err) {
    return err;
  }
}

// GET: Gets alerts for the manager
async function httpGetCompanyAlerts(id) {
  const token = Auth.getToken();
  try {
    let alerts = await fetch(`${API_URL}/companies/info/alerts/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await alerts.json();
  } catch (err) {
    return err;
  }
}

// GET: Fetches a single company form
async function httpGetCompanyForm(companyId, formId) {
  const token = Auth.getToken();

  try {
    let forms = await fetch(
      `${API_URL}/companies/forms/${companyId}/form/${formId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await forms.json();
  } catch (err) {
    return err;
  }
}
// GET: Fetches all the companies forms
async function httpGetCompanyForms(companyId, userId) {
  const token = Auth.getToken();

  try {
    let forms = await fetch(
      `${API_URL}/companies/forms/${companyId}/${userId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await forms.json();
  } catch (err) {
    return err;
  }
}

async function httpGetPurchaseHistory(id) {
  const token = Auth.getToken();
  try {
    // The routes have been merged company=true makes it hit the company endpoint
    let purchaseHistory = await fetch(
      `${API_URL}/users/courses/purchase-history/${id}?company=true`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await purchaseHistory.json();
  } catch (err) {
    return err;
  }
}

// GET: Get the previous versions of a form
async function httpGetPreviousFormVersions(formId) {
  const token = Auth.getToken();

  try {
    let versions = await fetch(
      `${API_URL}/companies/forms/previous-versions/${formId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return versions;
  } catch (err) {
    return err;
  }
}

// GET: Get all instances of a form with query params for filtering/pagination
function buildQueryString(query = {}) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  return params.toString() ? `?${params.toString()}` : '';
}

async function httpGetFormInstances(companyId, formId, query = {}) {
  const token = Auth.getToken();
  const queryString = buildQueryString(query);
  try {
    let instances = await fetch(
      `${API_URL}/companies/forms/${companyId}/instances/${formId}${queryString}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await instances.json();
  } catch (err) {
    console.log('Error fetching form instances:', err);
    return err;
  }
}

// GET: The users and provinces
async function httpGetCompanyUsersAndProvinces(id) {
  const token = Auth.getToken();
  try {
    let data = await fetch(`${API_URL}/companies/info/users-provinces/${id}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await data.json();
  } catch (err) {
    return err;
  }
}

// GET: The form instances from a user
async function httpGetFormInstancesFromUser(userId, formId) {
  const token = Auth.getToken();
  try {
    let instances = await fetch(
      `${API_URL}/companies/forms/instances/user/${userId}/form/${formId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
        cache: 'no-store',
      }
    );
    // console.log('Inside the hook for form instances', instances);
    let data = await instances.json();
    // console.log('Data:', data);
    return data;
  } catch (err) {
    return err;
  }
}

// GET: Companies povinces and pending forms
async function httpGetProvincesAndPendingForms(companyId) {
  const token = Auth.getToken();

  try {
    let data = await fetch(
      `${API_URL}/companies/forms/provinces-pending-forms/${companyId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );
    return await data.json();
  } catch (err) {
    return err;
  }
}

// GET: Gets the companies manual
async function httpGetManual(companyId) {
  const token = Auth.getToken();

  try {
    let manual = await fetch(`${API_URL}/companies/manuals/${companyId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
    return await manual.json();
  } catch (err) {
    return err;
  }
}

// GET: Training company subscription
async function httpGetCompanyTrainingAssignmentData(companyId, userId) {
  const token = Auth.getToken();

  try {
    const response = await fetch(
      `${API_URL}/companies/training/${companyId}/${userId}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }
    );

    const text = await response.text();

    if (!text) {
      return {
        success: false,
        message: 'No response received from the server.',
      };
    }

    try {
      return JSON.parse(text);
    } catch {
      return {
        success: false,
        message: 'The server returned an unexpected response.',
        rawResponse: text.slice(0, 300),
      };
    }
  } catch (err) {
    return {
      success: false,
      message: err?.message || 'Unable to load company training.',
    };
  }
}

export {
  httpGetCompany,
  httpGetCompanyManagers,
  httpGetCompanyEmployees,
  httpGetCompanyAlerts,
  httpGetCompanyForm,
  httpGetCompanyForms,
  httpGetPurchaseHistory,
  httpGetPreviousFormVersions,
  httpGetFormInstances,
  httpGetCompanyUsersAndProvinces,
  httpGetFormInstancesFromUser,
  httpGetProvincesAndPendingForms,
  httpGetManual,
  httpGetCompanyTrainingAssignmentData,
};
